import { ZSchemaValidatorFactory } from "./angular2-schema-form-shim";
import { SchemaErrorDetail } from "z-schema";
import { JSONSchema } from "./types/json-schema";
import { ZSchema } from "./types/z-schema";

let ZSchema: ZSchema = require( 'z-schema' );

import * as rawJSONSchemaMeta from '../schemas/schema.json';

export class SPSchemaValidatorFactory extends ZSchemaValidatorFactory {

  protected zschema: ZSchema;

  constructor() {
    super();

    this.zschema = new ZSchema( {
      breakOnFirstError: false,
    } );

    let metaSchemas: JSONSchema[] = [
      rawJSONSchemaMeta,
    ];
    metaSchemas.forEach( metaSchema => this.addRemoteReference( metaSchema.id, metaSchema ) );
  }

  createValidatorFn( schema: JSONSchema ) {
    return ( value ): SchemaErrorDetail[] => {

      // Entire current property is missing, don't try to validate it directly, let the parent handle it
      if ( this.isPropertyMissing( value, schema ) ) {
        return null;
      }

      value = this.cleanupValue( value, schema );

      this.zschema.validate( value, schema );
      let err: SchemaErrorDetail[] = this.zschema.getLastErrors();

      this.fixPropertyPaths( err, schema );

      return err || null;
    };
  }

  cleanupValue( value: any, schema: JSONSchema ): any {
    value = this.deleteNullProperties( value, schema );

    if ( schema.type === 'number' || schema.type === 'integer' ) {
      value = +value;
    }

    return value;
  }

  isPropertyMissing( value: any, schema: JSONSchema ) {
    if ( Array.isArray( schema.type ) && schema.type.includes( 'null' ) && value === null ) {
      return true;
    }
    return (
      ( ( value === null || value === '' ) && schema.type === 'string' ) ||
      ( value === null && ( schema.type === 'number' || schema.type === 'integer' || schema.type === 'boolean' ) )
    );
  }

  deleteNullProperties( values: any, schema: JSONSchema ) {
    for ( let property in values ) {
      if ( values.hasOwnProperty( property ) && this.isPropertyMissing( values[ property ], schema ) ) {
        delete values[ property ];
      } else if ( schema.type === 'array' ) {
        if ( schema.items instanceof Array ) {
          values[ property ] = this.deleteNullProperties( values[ property ], schema.items[ property ] );
        } else {
          values[ property ] = this.deleteNullProperties( values[ property ], schema.items );
        }
      } else if ( values[ property ] === null && schema.properties && schema.properties[ property ] &&
                  this.isPropertyMissing( null, schema.properties[ property ] ) ) {
        delete values[ property ];
      } else if ( typeof values[ property ] === 'object' ) {
        values[ property ] = this.deleteNullProperties( values[ property ], schema.properties[ property ] );
      }
    }
    return values;
  }

  protected fixPropertyPaths( err: SchemaErrorDetail[], schema: JSONSchema ) {
    if ( err && err.length ) {
      err = err.map( error => {
        if ( error.path === '#/' && schema.path ) {
          error.path = schema.path;
        }
        // Required property errors are technically an error on the parent.
        // Move the error to the missing property instead for ease of display.
        if ( error.code === 'OBJECT_MISSING_REQUIRED_PROPERTY' ) {
          error.code = 'PROPERTY_VALUE_REQUIRED';
          error.path += ( error.path === '#/' ? '' : '/' ) + error.params[ 0 ];
        }
        return error;
      } );
    }
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/schemavalidatorfactory.ts